var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"main-section"},[_c('section',{staticClass:"left-section"},[_c('LeftPanel')],1),_c('section',{staticClass:"right-section"},[_c('RightPanel')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }